/**
 * @module components/AlertLoading
 * @author Charles Blais <charles.blais@canada.ca>
 */

import React from 'react';
import PropTypes from 'prop-types';

import AlertLoading from './AlertLoading';
import AlertError from './AlertError';


const UserFeedback = ({isLoading, isError}) => {
  if( isLoading ) {
    return ( <AlertLoading /> );
  }
  if( isError ) {
    return ( <AlertError /> );
  }
  return null;
}


UserFeedback.propTypes = {
  /**
   * Render as a loading message
   */
  isLoading: PropTypes.bool,
  /**
   * Render as a error message
   */
  isError: PropTypes.bool,
};


UserFeedback.defaultProps = {
  isLoading: false,
  isError: false
};


export default UserFeedback;